const dictionaryItems = {
  shareClassLaunchDate: {
    name: 'fundDetailsKeyInfoShareClassLaunchDate',
    type: 'date',
  },
  benchmark: {
    name: 'fundDetailsKeyInfoBenchmark',
    type: 'string',
  },
  underlyingYield: {
    name: 'fundDetailsKeyInfoUnderlyingYield',
    type: 'number',
  },
  distributionYield: {
    name: 'fundDetailsKeyInfoDistributionYield',
    type: 'number',
  },
  historicYield: {
    name: 'fundDetailsKeyInfoHistoricYield',
    type: 'number',
  },
  managementCosts: {
    name: 'fundDetailsKeyInfoManagementCost',
    type: 'percentage',
  },
  baseCurrency: {
    name: 'fundDetailsKeyInfoBaseCurrency',
    type: 'string',
  },
  managementFee: {
    name: 'fundDetailsKeyInfoManagementFee',
    type: 'percentage',
  },
  frontEndLoad: {
    name: 'fundDetailsKeyInfoFrontEndLoad',
    type: 'percentage',
  },
  fundLaunchDate: {
    name: 'fundDetailsKeyInfoFundLaunchDate',
    type: 'date',
  },
  fundSize: {
    name: 'fundDetailsKeyInfoFundSize',
    type: 'number',
  },
  domicile: {
    name: 'fundDetailsKeyInfoDomicile',
    type: 'string',
  },
  trustee: {
    name: 'fundDetailsKeyInfoTrustee',
    type: 'string',
  },
  registrar: {
    name: 'fundDetailsKeyInfoRegistrar',
    type: 'string',
  },
  auditor: {
    name: 'fundDetailsKeyInfoAuditor',
    type: 'string',
  },
  fundType: {
    name: 'fundDetailsKeyInfoFundType',
    type: 'string',
  },
  buySellSpread: {
    name: 'fundDetailsKeyInfoBuySellSpread',
    type: 'string',
  },
  highestNav: {
    name: 'fundDetailsKeyInfoHighestNav',
    type: 'object',
  },
  lowestNav: {
    name: 'fundDetailsKeyInfoLowestNav',
    type: 'object',
  },
  minInitialInvestment: {
    name: 'fundDetailsKeyInfoMinInitialInvestment',
    type: 'string',
  },
  performanceTarget: {
    name: 'fundDetailsKeyInfoPerformanceTarget',
    type: 'string',
  },
  performanceComparator: {
    name: 'fundDetailsKeyInfoPerformanceComparator',
    type: 'string',
  },
  portfolioConstrainingBenchmark: {
    name: 'fundDetailsKeyInfoPortfolioConstrainingBenchmark',
    type: 'string',
  },
  entryCharge: {
    name: 'fundDetailsKeyInfoEntryCharge',
    type: 'string',
  },
  valuationPoint: {
    name: 'fundDetailsKeyInfoValuationPoint',
    type: 'string',
  },
  switchingFee: {
    name: 'fundDetailsKeyInfoSwitchingFee',
    type: 'percentage',
  },
  fundIncludedUnder: {
    name: 'fundDetailsKeyInfoFundIncludedUnder',
    type: 'string',
  },
  numberOfHoldings: {
    name: 'fundDetailsKeyInfoNumberOfHoldings',
    type: 'string',
  },
  wal: {
    name: 'fundDetailsKeyInfoWal',
    type: 'string',
  },
  wam: {
    name: 'fundDetailsKeyInfoWam',
    type: 'string',
  },
  dailyAmcPerCent: {
    name: 'fundDetailsKeyInfoDailyAmcPerCent',
    type: 'percentage',
  },
  accountType: {
    name: 'fundDetailsKeyInfoAccountType',
    type: 'string',
  },
  custodian: {
    name: 'fundDetailsKeyInfoCustodian',
    type: 'string',
  },
  investmentManager: {
    name: 'fundDetailsKeyInfoInvestmentManager',
    type: 'string',
  },
  isaEligibility: {
    name: 'fundDetailsKeyInfoIsaEligibility',
    type: 'string',
  },
  issuingCompany: {
    name: 'fundDetailsKeyInfoIssuingCompany',
    type: 'string',
  },
  managementApproach: {
    name: 'fundDetailsKeyInfoManagementApproach',
    type: 'string',
  },
  managementCompany: {
    name: 'fundDetailsKeyInfoManagementCompany',
    type: 'string',
  },
  rebalanceFrequency: {
    name: 'fundDetailsKeyInfoRebalanceFrequency',
    type: 'string',
  },
  sfdrClassification: {
    name: 'fundDetailsKeyInfoSfdrClassification',
    type: 'string',
  },
  sippAvailable: {
    name: 'fundDetailsKeyInfoSippAvailable',
    type: 'string',
  },
  isin: {
    name: 'fundDetailsKeyInfoIsin',
    type: 'string',
  },
  netAssets: {
    name: 'fundDetailsKeyInfoNetAssets',
    type: 'numberWithStandardNotation',
  },
  shareClassCurrency: {
    name: 'fundDetailsKeyInfoShareClassCurrency',
    type: 'string',
  },
  sharesOutstanding: {
    name: 'fundDetailsKeyInfoSharesOutstanding',
    type: 'numberWithoutDecimals',
  },
  taxStatus: {
    name: 'fundDetailsKeyInfoTaxStatus',
    type: 'string',
  },
  totalExpenseRatio: {
    name: 'fundDetailsKeyInfoTotalExpenseRatio',
    type: 'percentage',
  },
  ucits: {
    name: 'fundDetailsKeyInfoUcits',
    type: 'string',
  },
  useOfIncome: {
    name: 'fundDetailsKeyInfoUseOfIncome',
    type: 'string',
  },
  amcPerCent: {
    name: 'fundDetailsKeyInfoAmcPerCent',
    type: 'percentage',
  },
  netExpenseRatio: {
    name: 'fundDetailsKeyInfoNetExpenseRatio',
    type: 'percentage',
  },
  currencyHedged: {
    name: 'fundDetailsKeyInfoCurrencyHedged',
    type: 'string',
  },
  dividendFrequency: {
    name: 'fundDetailsKeyInfoDividendFrequency',
    type: 'string',
  },
  exposure: {
    name: 'fundDetailsKeyInfoExposure',
    type: 'string',
  },
  assetClass: {
    name: 'fundDetailsKeyInfoAssetClass',
    type: 'string',
  },
  legalStructure: {
    name: 'fundDetailsKeyInfoLegalStructure',
    type: 'string',
  },
  grossExpenseRatio: {
    name: 'fundDetailsKeyInfoGrossExpenseRatio',
    type: 'numberWithStandardNotation',
  },
  ticker: {
    name: 'fundDetailsKeyInfoTicker',
    type: 'string',
  },
  cusip: {
    name: 'fundDetailsKeyInfoCusip',
    type: 'string',
  },
  fundManager: {
    name: 'fundDetailsKeyInfoFundManager',
    type: 'string',
  },
  inceptionDate: {
    name: 'fundDetailsKeyInfoInceptionDate',
    type: 'date',
  },
  netAssetValue: {
    name: 'fundDetailsKeyInfoNetAssetValue',
    type: 'number',
  },
  primaryBenchmark: {
    name: 'fundDetailsKeyInfoPrimaryBenchmark',
    type: 'string',
  },
  sevenDayNetYield: {
    name: 'fundDetailsKeyInfoSevenDayNetYield',
    type: 'number',
  },
  m2mVsAmortised: {
    name: 'fundDetailsKeyInfoM2mVsAmortised',
    type: 'number',
  },
  medianBidAskSpread: {
    name: 'fundDetailsKeyInfoMedianBidAskSpread',
    type: 'percentage',
  },
  basketSizeGold: {
    name: 'fundDetailsKeyInfoBasketSizeGold',
    type: 'number',
  },
  basketSizePalladium: {
    name: 'fundDetailsKeyInfoBasketSizePalladium',
    type: 'number',
  },
  basketSizePlatinum: {
    name: 'fundDetailsKeyInfoBasketSizePlatinum',
    type: 'number',
  },
  basketSizeSilver: {
    name: 'fundDetailsKeyInfoBasketSizeSilver',
    type: 'number',
  },
  cefTickerSymbol: {
    name: 'fundDetailsKeyInfoCefTickerSymbol',
    type: 'string',
  },
  cefSharesOutstanding: {
    name: 'fundDetailsKeyInfoCefSharesOutstanding',
    type: 'string',
  },
  cefManagedAssets: {
    name: 'fundDetailsKeyInfoCefManagedAssets',
    type: 'string',
  },
  cefNetAssets: {
    name: 'fundDetailsKeyInfoCefNetAssets',
    type: 'string',
  },
  cefFiscalYearEnd: {
    name: 'fundDetailsKeyInfoCefFiscalYearEnd',
    type: 'string',
  },
  cefMarketDistributionRate: {
    name: 'fundDetailsKeyInfoCefMarketDistributionRate',
    type: 'string',
  },
  cefNavDistributionRate: {
    name: 'fundDetailsKeyInfoCefNavDistributionRate',
    type: 'string',
  },
  cefGrossExpenseRatio: {
    name: 'fundDetailsKeyInfoCefGrossExpenseRatio',
    type: 'string',
  },
  cefNetExpenseRatio: {
    name: 'fundDetailsKeyInfoCefNetExpenseRatio',
    type: 'string',
  },
  iopvValue: {
    name: 'fundDetailsKeyInfoIopvValue',
    type: 'number',
  },
  iopvDate: {
    name: 'fundDetailsKeyInfoIopvDate',
    type: 'UTCDate',
  },
  sdrClassification: {
    name: 'fundDetailsKeyInfoSdrClassification',
    type: 'string',
  },
  sdrLabel: {
    name: 'fundDetailsKeyInfoSdrLabel',
    type: 'string',
  },
  fundSizeWithDate: {
    name: 'fundDetailsAum',
    type: 'UTCDate',
  },
  shareClassDividendFrequency: {
    name: 'fundDetailsKeyInfoShareClassDividendFrequency',
    type: 'string',
  },
  isHedged: {
    name: 'fundDetailsKeyInfoIsHedged',
    type: 'string',
  },
};
export default dictionaryItems;
